import { Locales } from 'src/i18n'
import Translation from '../shared/interfaces/Translation'
import LockerTypeTranslationJson from './interfaces/LockerTypeTranslationJson'

export default class LockerTypeTranslation implements Translation {
  locale: Locales
  name: string

  constructor(locale: Locales, name: string) {
    this.locale = locale
    this.name = name
  }

  static fromJson(data: LockerTypeTranslationJson) {
    return new this(data.locale, data.name)
  }

  toJson(): LockerTypeTranslationJson {
    return {
      locale: this.locale,
      name: this.name,
    }
  }
}
